export const DASH_REGEX = /[\u2012\u2013\u2014\u2015\-]+/g;

export const WHITESPACES_REGEX = /\s+/g;

export const UPPERCASE_FIRST_LETTERS_REGEX = /(^\w{1})|(\s+\w{1})/g;
